import http from '../../http/requests/data/index.js'

export default {
  uploadXlsxFile({commit}, payload) {
    return new Promise((resolve, reject) => {
      http.uploadXlsxFile(payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  uploadXmlFile({commit}, payload) {
    return new Promise((resolve, reject) => {
      http.uploadXmlFile(payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchData({commit}, payload) {
    return new Promise((resolve, reject) => {
      http
        .fetchData(payload)
        .then((response) => {
          commit('SET_DATA', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchXMLData({commit}, payload) {
    return new Promise((resolve, reject) => {
      http
        .fetchXMLData(payload)
        .then((response) => {

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchLongParkingData({commit}, payload) {
    return new Promise((resolve, reject) => {
      http
        .fetchLongParkingData(payload)
        .then((response) => {

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchFileList({commit}) {
    return new Promise((resolve, reject) => {
      http
        .fetchFileList()
        .then((response) => {
          commit('SET_FILE_LIST', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteFileByID({commit}, fileID) {
    return new Promise((resolve, reject) => {
      http
        .deleteFileByID(fileID)
        .then((response) => {
          commit('DELETE_FILE_FROM_FILE_LIST', fileID)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
